import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowWhite, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';


const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '15.04.2025',
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '12.04.2025',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '10.04.2025',
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
];
 
const CareersJobsDetailItems = () => {


      const { t } = useTranslation();

      const { id } = useParams();

      const [singleNews, setSingleNews] = useState("")

      useEffect(() => {


        const filteredTour = newsItems.find(product => product.id == id);
        setSingleNews(filteredTour);
    
      }, []);

  return (
    <div className='mt-[88px] md:mt-[104px]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className=' text-[#1C1C1C]'>
    <p className='text-[26px] font-medium'>{singleNews.title}</p>
    <p className='mt-6'>{singleNews.description}</p>
    <a href='/contact'>
                           <div className='flex justify-between items-center w-[206px] mt-[48px] rounded-[12px] bg-[#01A396] text-[white] px-5 h-[46px]'>
                              <p>Müraciət et</p>
                              <img className='w-4' src={rightArrowWhite}></img>
                            </div>
                           </a>
          </div>
       </div>
    </div>
  )
}

export default CareersJobsDetailItems